
// outsource dependencies
import _ from 'lodash';
import { toastr } from 'react-redux-toastr';
import { create } from 'redux-saga-controller';
import { takeEvery, put, call, select } from 'redux-saga/effects';

// local dependencies
import { APP_TITLE, USER_LIST, USER_STATE } from '../../../constant';
import { formatFullName, instanceAPI, SweetAlert } from '../../../services';

// configure
export const usersListCtrl = create({
  prefix: 'users-list',
  actions: {
    initialize: 'INITIALIZE',
    deleteItem: 'DELETE_ITEM',
    updateFilter: 'UPDATE_FILTER',
  },
  initial: {
    list: [],
    disabled: false,
    initialized: false,
    errorMessage: null,
    // filters
    page: 0,
    size: 10,
    search: '',
    sortD: false,
    totalPages: 0,
    sortF: 'createdDate',
    status: USER_STATE.ACTIVE,
  },
  subscriber: function * () {
    yield takeEvery(usersListCtrl.action.initialize.TYPE, initializeSaga);
    yield takeEvery(usersListCtrl.action.deleteItem.TYPE, deleteItemSaga);
    yield takeEvery(usersListCtrl.action.updateFilter.TYPE, updateFilterSaga);
  }
});

function * initializeSaga () {
  yield put(usersListCtrl.action.clearCtrl());
  const query = yield call(USER_LIST.QUERY);
  yield call(updateFilterSaga, { payload: { ...query } });
  yield put(usersListCtrl.action.updateCtrl({ initialized: true }));
}

function * updateFilterSaga ({ payload }) {
  yield put(usersListCtrl.action.updateCtrl({ ...payload, disabled: true }));
  try {
    const { page, search, status, size, sortF, sortD, } = yield select(usersListCtrl.select);
    const { content, totalPages, pageNumber } = yield call(instanceAPI, {
      method: 'POST',
      url: '/users/filter',
      data: { search, userState: status },
      params: { page, size, sort: [`${sortF},${sortD ? 'DESC' : 'ASC'}`] },
    });
    yield put(usersListCtrl.action.updateCtrl({ list: content, totalPages, page: pageNumber }));
    const latest = yield select(usersListCtrl.select);
    yield call(USER_LIST.REPLACE, {}, latest);
  } catch ({ message }) {
    yield put(usersListCtrl.action.updateCtrl({ errorMessage: message }));
  }
  yield put(usersListCtrl.action.updateCtrl({ disabled: false }));
}

function * deleteItemSaga ({ type, payload }) {
  const id = _.get(payload, 'id');
  const name = formatFullName(payload);
  try {
    const confirmation = yield call(SweetAlert.confirm, {
      title: `Are you sure you want to delete user "${name}"?`
    });
    if (!confirmation.value) { return null; }
    yield put(usersListCtrl.action.updateCtrl({ disabled: true }));
    // TODO wait BE implementation
    yield call(instanceAPI, { method: 'DELETE', url: `/users/${id}` });
    yield call(toastr.success, APP_TITLE, 'The user status has been changed to inactive!');
    yield put(usersListCtrl.action.initialize({}));
  } catch ({ message }) {
    yield call(SweetAlert.error, { title: message });
  }
  yield put(usersListCtrl.action.updateCtrl({ disabled: false }));
}
